export default class Artist{
    id;
    name;
    profilePicture;
    professions;
    visibleOnWebsite;
    years;
}